import React, { Component } from 'react';

import { Link } from 'react-router-dom';

// import { PopupboxManager, PopupboxContainer } from 'react-popupbox';

import swal from '@sweetalert/with-react';

import * as API from '../../helpers/apiHelper';

import createNewHistory from '../../services/userHistory';

import { getTokenData } from '../../helpers/authHelper';

import api from '../../services/api';

// Components

import UserList from './list';

// styles

import { Box, BtnCadastrar } from './styles';

// import { Box, UserList, Popup } from './styles';

class Usuarios extends Component {
  state = {
    users: [],

    listStatus: false,

    isLoading: false,

    newusername: '',

    newpassword: '',

    newadmin: false,

    addUserForm: false,
  };

  async componentDidMount() {
    this.loadUserList();

    const history = {
      route: 'USUÁRIOS',
      method: 'ACESSO',
      description: {},
      userUuid: getTokenData().user.uuid,
    };

    await createNewHistory({ ...history });
  }

  handleChange = field => e => {
    this.setState({
      [field]: e.target.value,
    });

    // console.log(this.state.newadmin);
  };

  handleChangeAdmin = () => {
    this.setState(prevState => ({
      newadmin: !prevState.newadmin,
    }));
  };

  btnFilter = () => {
    this.setState(prevState => ({
      addUserForm: !prevState.addUserForm,
    }));

    // alert(this.state.addUserForm);

    // const filter = document.querySelector('.filter-box');

    // filter.classList.toggle('active');

    // const btn = document.querySelector('.btn-filter-nfs');

    // btn.classList.toggle('active');
  };

  // openPopupbox = () => {

  //   const content = (

  //     <Popup>

  //       <div className="content">

  //         <h2>Alterar usuário</h2>

  //         <div className="list-justificativas">

  //           <div className="item">

  //             <div className="user">

  //               <input type="checkbox" />

  //               <p>Romero Almeida</p>

  //               <p>12/07/2019 08:16:21</p>

  //               <p>XO - AGENDAMENTO</p>

  //             </div>

  //           </div>

  //         </div>

  //       </div>

  //       <div className="wrap-btns">

  //         <div className="btnclose" onClick={PopupboxManager.close}>

  //           x

  //         </div>

  //         <button type="button" className="btn abonar">

  //           Abonar

  //         </button>

  //         <button type="button" className="btn">

  //           Justificativas

  //         </button>

  //         <button type="button" className="btn">

  //           Adicionar

  //         </button>

  //       </div>

  //     </Popup>

  //   );

  //   PopupboxManager.open({ content });

  // };

  addUser = async () => {
    const { newusername, newpassword, newadmin } = this.state;

    const newUser = await API.APIpost(`users`, {
      user: {
        username: newusername,

        password: newpassword,

        admin: newadmin,
      },
    });

    console.log(newUser);

    window.location.reload();
  };

  deleteUser = async uuid => {
    console.log(uuid);

    const confirmDelete = await swal({
      dangerMode: true,

      text: 'Confirma a bloqueio do usuário?',

      buttons: {
        cancel: 'Não',

        confirm: 'Sim',
      },
    });

    if(confirmDelete) {
      await API.APIdelete(`users/${uuid}`);
    }

    window.location.reload();
  };

  restoreUser = async uuid => {
    const data = {
      dt_exclusao: null,
    };

    await api.put(`/users/restore/${uuid}`, {...data});

    window.location.reload();
  }

  modifyUser = async uuid => {
    // alert('Tela/popup de alteração ainda não implementado');

    // this.openPopupbox();

    const confirmDelete = await swal({
      dangerMode: true,

      text: 'Confirma a exclusão do usuário?',

      buttons: {
        cancel: 'Não',

        confirm: 'Sim',
      },
    });

    if (confirmDelete) {
      this.deleteUser(uuid);
    }
  };

  async loadUserList(status) {
    // tem que buscar os USUARIOS
    this.setState({
      isLoading: true,
      listStatus: status,
    });

    const users = await API.APIget(`users/all/${status || null}`);

    // NOVA API COMEX
    // const userStatus = status ? 'blocked' : 'active';
    // const users = await API.APIget(`users/all/${userStatus}`);

    if (users) this.setState({ users: users.data });

    this.setState({ isLoading: false });
  }

  render() {
    // const popupboxConfig = {

    //   fadeIn: true,

    //   fadeInSpeed: 500,

    // };

    const {
      isLoading,

      users,

      addUserForm,

      newusername,

      newpassword,

      newadmin,

      listStatus,
    } = this.state;

    return (
      <div>
        <div className="center">
          <div className="page-header">
            <h1>Usuários</h1>

            <div className="last-wrap">
              <BtnCadastrar
                type="button"
                className="filter"
                styles={{
                  marginRight: '16px'
                }}
                onClick={() => this.loadUserList(!listStatus)}
              >
                {`Mostrar ${ !listStatus ? 'bloqueados' : 'desbloqueados'}`}
              </BtnCadastrar>
              <Link onClick={this.btnMenu} to="/usuarios/novo">
                <BtnCadastrar>Adicionar usuário</BtnCadastrar>
              </Link>
            </div>
          </div>

          <div>
            <div>
              <div className="row">
                <Box className={addUserForm && 'active'}>
                  {/* <Box className="active"> */}

                  <form action="">
                    {/* <div className="item">

                      <label>Nome:</label>

                      <input

                        type="text"

                        value={name}

                        onChange={this.handleChange('name')}

                        placeholder="Nome Completo"

                        id="txtname"

                      />

                    </div> */}

                    <div className="item">
                      <label>E-mail:</label>

                      <input
                        type="email"
                        value={newusername}
                        onChange={this.handleChange('newusername')}
                        placeholder="teste@email.com.br"
                        id="txtemail"
                      />
                    </div>

                    <div className="item">
                      <label>Senha:</label>

                      <input
                        type="password"
                        value={newpassword}
                        onChange={this.handleChange('newpassword')}
                        placeholder="Senha de Acesso"
                        id="txtpassword"
                      />
                    </div>

                    <div className="nfs">
                      <label>
                        <input
                          type="checkbox"
                          name=""
                          value={newadmin}
                          onChange={this.handleChangeAdmin}
                          id="checkAdmin"
                        />
                        Administrador
                      </label>
                    </div>

                    <div className="item">
                      <label> &nbsp; </label>

                      <button
                        type="button"
                        onClick={this.addUser}
                        className="btn"
                      >
                        Cadastrar
                      </button>
                    </div>
                  </form>
                </Box>
              </div>
            </div>
            {/* <PopupboxContainer {...popupboxConfig} /> */}
              <UserList
                users={users}
                isLoading={isLoading}
                onUserDelete={this.deleteUser}
                onUserRestore={this.restoreUser}
              />
          </div>
        </div>
      </div>
    );
  }
}

export default Usuarios;
